/**
 * Summon ground-ring feel — single knob file (constants extraction,
 * 2026-06-12).
 *
 * Consumed by SummonVFXHandler: every placed summon (trap/totem/other) gets
 * a pulsing ground ring; trigger flashes + expands it, expiry fades it out.
 */
export const SUMMON_RING_CONFIG = {
  /** Ring color by summon type; unknown types fall through to `default`. */
  colors: {
    trap: 0xFF4444,
    totem: 0x44FF44,
    default: 0x4488FF,
  },
  /** Ring fill alpha at rest (the pulse multiplies this). */
  fillAlpha: 0.1,
  /** Ring outline stroke width (px). */
  strokeWidth: 2,
  /** Ring outline stroke alpha. */
  strokeAlpha: 0.5,
  /** Render depth (ground layer, under entities). */
  depth: 50,
  /**
   * setAlpha = state.alpha × fillAlpha × alphaGain, clamped 0..1. The gain
   * lifts the deliberately-faint fill into a visible on-screen pulse range
   * (0.1 base × 5 = 0.5 at rest, 1.0 at pulse peak).
   */
  alphaGain: 5,
  /** Resting pulse: infinite sine yoyo. */
  pulse: { durationMs: 800, alphaMultiplierTo: 2, scaleTo: 1.05 },
  /** Trigger beat: flash + expand, then destroy. */
  triggered: { durationMs: 300, scaleTo: 2 },
  /** Expiry beat: fade out, then destroy. */
  expired: { durationMs: 500 },
} as const;

/** Resolve a summon type to its ring color (unknown → default blue). */
export function summonRingColor(type: string | undefined): number {
  const colors = SUMMON_RING_CONFIG.colors as Record<string, number>;
  return colors[type ?? ''] ?? SUMMON_RING_CONFIG.colors.default;
}
